import {
    Box, Button, FormControl, Grid, InputLabel, Link, Select, Typography
} from "@material-ui/core";
import React from "react";
import { DeviceInfo, ExecutionType, Order } from "../../../Shared/GeneratedTypes";
import Loading from "../../../Shared/loading";
import { Localizations } from "../../../Shared/sharedTypes";
import Util from "../../../Shared/utilties";
import "./Phases.css";

interface propsType {
    next: () => void;
    order: Order;
    device: DeviceInfo | null | undefined;
    localizations: Localizations;
    apiCallsInProgress: number;
    updateCulture: (culture: string) => void;
    viewCookieDisclosure: () => void;
}

export default function Welcome({ order, next, localizations, apiCallsInProgress, updateCulture, viewCookieDisclosure, device }: propsType) {
    var opts = [];
    var languages = order.customer.languages;
    
    let isAdHocSession = order.executionType === ExecutionType.AdHoc;

    for (var key in languages) {
        opts.push(
            <option key={key} value={languages[key]}>
                {key}
            </option>
        );
    }

    if (apiCallsInProgress > 0) {
        return (
            <>
                <Box textAlign="center">
                    <Loading message={localizations.updatingLanguage}></Loading>
                </Box>
            </>
        );
    } else {
        return (
            <>
                <Grid item className="PhaseTopSection">
                    <Box textAlign="center">
                        <img
                            src={order.logoPhotoUrl}
                            alt="carrier logo"
                            style={{
                                marginTop: 24,
                                marginBottom: 12,
                                height: "120px",
                                maxWidth: "90%",
                                filter: "drop-shadow(rgba(200, 200, 200, 0.5) 3px 2px 11px)",
                            }}
                        />
                    </Box>
                    {languages != null && Object.keys(languages).length > 1 ? (
                        <Box textAlign="center">
                            <FormControl variant="outlined" required style={{ minWidth: "200px", margin: "8px" }}>
                                <InputLabel htmlFor="language-picker">{localizations.languageSelection}</InputLabel>
                                <Select
                                    value={order.cultureCode}
                                    native
                                    label={localizations.languageSelection}
                                    inputProps={{ id: "language-picker" }}
                                    onChange={(
                                        e: React.ChangeEvent<{
                                            value: unknown;
                                        }>
                                    ) => updateCulture(e.target.value as string)}
                                >
                                    {opts}
                                </Select>
                            </FormControl>
                        </Box>
                    ) : (
                            <></>
                        )}
                    <Box m={3}>
                        <Typography variant="h5">
                            {Util.format(localizations.Salutation, { firstName: order.contact.firstName })}
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: isAdHocSession
                                    ? localizations.WelcomeMessageInstant
                                    : localizations.WelcomeMessageScheduled
                            }}
                        ></Typography>
                    </Box>
                </Grid>
                <Grid item className="footer">
                    <Box style={{ marginBottom: 15 }}>
                        <Typography variant="body1">
                            {localizations.cookieDisclosureMessage}
                        </Typography>
                        <Button
                            color="primary"
                            onClick={() => { viewCookieDisclosure() }}
                            classes={{ label: 'underline' }}
                        >{localizations.cookieDisclosureLink}</Button>
                    </Box>

                    <Button
                        size="large"
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => next()}
                    >
                        {localizations.BeginSession}
                    </Button>
                </Grid>
            </>
        );
    }
}
